import { createAsyncThunk } from "@reduxjs/toolkit"
import { serverApi, handleApiResponse, handleReferenceResponse, getAuthHeaders, queApi } from "@core/api/core"
import { buhangcupSerializer, buhangcupListResponse } from "@/types/buhangcup"

type FetchBuhangcupsParams = {
  validOnly?: boolean
}

export const fetchBuhangcups = createAsyncThunk<buhangcupSerializer[], FetchBuhangcupsParams | undefined, { rejectValue: string }>(
  "suga/fetchBuhangcups",
  async (params, { rejectWithValue }) => {
    try {
      const requestUrl = `/reference/buhangcup/`
      const response = await queApi.get<buhangcupListResponse>(requestUrl, {
        params: params?.validOnly === undefined ? undefined : { validOnly: params.validOnly },
      })

      const data = handleReferenceResponse(response)

      const buhancups: buhangcupSerializer[] = data.results.map(row => {
        // columns[i] ↔ row[i] 매핑
        const obj = Object.fromEntries(data.columns.map((col, i) => [col, row[i]])) as Record<string, number | string | boolean | null>

        return {
          buhangcupId: Number(obj["buhangcupId"]),
          buhangcupCode: String(obj["buhangcupCode"]),
          buhangcupName: String(obj["buhangcupName"]),
          buhangcupCompany: String(obj["buhangcupCompany"]),
          buhangcupMaxPrice: Number(obj["buhangcupMaxPrice"]),
          isCurrentValid: obj["isCurrentValid"] === undefined ? undefined : Boolean(obj["isCurrentValid"]),
          effectiveDate: String(obj["effectiveDate"]),
          // 만약 obj["expirationDate"]가 null이면 ""을 넣도록 처리
          expirationDate: obj["expirationDate"] !== null ? String(obj["expirationDate"]) : "",
        }
      })
      // console.log("fetchBuhangcups", buhancups)
      return buhancups
    } catch (err: any) {
      return rejectWithValue(err.message || "부항컵 정보 조회에 실패했습니다.")
    }
  }
)
